import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/sysCarMeta/pageList',
method: 'get',
params: query
})
}
 
export function qrcode(encryptId) {
    return request({
    url: `/api/admin/sysCarMeta/qrcode`,
    method: 'get',
    params: { "encryptId": encryptId}
    })
}

export function addObj(obj) {
return request({
url: '/api/admin/sysCarMeta',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/sysCarMeta/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/sysCarMeta/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/sysCarMeta/' + id,
method: 'put',
data: obj
})
}
